import { usePopover as t } from "../../Popover/hooks/usePopover.js";
import { useMenu as n } from "./useMenu.js";
const i = (r) => {
  const s = t(), o = n(), e = r ?? (o == null ? void 0 : o.role);
  return s || !e ? !1 : ["menu", "listbox"].includes(e);
};
export {
  i as useMenuComposite
};
